"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useDocumentEvent_1 = require("./useDocumentEvent");
var useEnterPress = function (onEnter) {
    useDocumentEvent_1.default("keydown", react_1.useCallback(function (event) {
        if (event instanceof KeyboardEvent && event.key === "Enter") {
            onEnter();
        }
    }, [onEnter]));
};
exports.default = useEnterPress;
